/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../../../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type SubmitVisionLookFeedbackMutationVariables = Types.Exact<{
  input: Types.VisionLookFeedbackSubmitInput;
}>;
export type SubmitVisionLookFeedbackMutation = {
  __typename?: "Mutation";
  visionLookFeedbackSubmit?: {
    __typename?: "VisionLookFeedbackSubmitPayload";
    result: {
      __typename?: "VisionLookFeedbackSubmitError";
      message: string;
    } | {
      __typename?: "VisionLookFeedbackSubmitSuccess";
      feedbackQuestions: Array<{
        __typename?: "LookFeedbackFreeformTextQuestion";
        answer?: string | null;
        questionId: string;
      } | {
        __typename?: "LookFeedbackMultipleChoiceQuestion";
        answer?: string | null;
        questionId: string;
      }>;
    };
  } | null;
};
export const SubmitVisionLookFeedbackDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "submitVisionLookFeedback"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "input"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "VisionLookFeedbackSubmitInput"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "visionLookFeedbackSubmit"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "input"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "result"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "InlineFragment",
                typeCondition: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "VisionLookFeedbackSubmitSuccess"
                  }
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "feedbackQuestions"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "answer"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "questionId"
                        }
                      }]
                    }
                  }]
                }
              }, {
                kind: "InlineFragment",
                typeCondition: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "VisionLookFeedbackSubmitError"
                  }
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "message"
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export type SubmitVisionLookFeedbackMutationFn = Apollo.MutationFunction<SubmitVisionLookFeedbackMutation, SubmitVisionLookFeedbackMutationVariables>;

/**
 * __useSubmitVisionLookFeedbackMutation__
 *
 * To run a mutation, you first call `useSubmitVisionLookFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitVisionLookFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitVisionLookFeedbackMutation, { data, loading, error }] = useSubmitVisionLookFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitVisionLookFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<SubmitVisionLookFeedbackMutation, SubmitVisionLookFeedbackMutationVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useMutation<SubmitVisionLookFeedbackMutation, SubmitVisionLookFeedbackMutationVariables>(SubmitVisionLookFeedbackDocument, options);
}
export type SubmitVisionLookFeedbackMutationHookResult = ReturnType<typeof useSubmitVisionLookFeedbackMutation>;
export type SubmitVisionLookFeedbackMutationResult = Apollo.MutationResult<SubmitVisionLookFeedbackMutation>;
export type SubmitVisionLookFeedbackMutationOptions = Apollo.BaseMutationOptions<SubmitVisionLookFeedbackMutation, SubmitVisionLookFeedbackMutationVariables>;